import { render, staticRenderFns } from "./SingleHeader.vue?vue&type=template&id=58ab7607&scoped=true&"
import script from "./SingleHeader.vue?vue&type=script&lang=js&"
export * from "./SingleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SingleHeader.vue?vue&type=style&index=0&id=58ab7607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab7607",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleHeader.vue
// module id = 286
// module chunks = 0